import React, { ReactChild, ReactFragment, ReactPortal } from 'react';

import styles from './AuthFormLayout.module.scss';

import logo from 'assets/images/logo.png';
import { CustomButton } from 'components/CustomButton';
import { LeftArrow } from 'assets';
import { routes } from 'enums';
import { useNavigate } from 'react-router-dom';

type ReactNode = ReactChild | ReactFragment | ReactPortal | boolean | null | undefined;

interface IAuthFormLayoutProps {
  children: ReactNode;
  onSubmit: () => void;
  handleResendResetClick?: () => void;
  title: string;
  subtitle?: string;
  bottomText?: string;
  isArrow?: boolean;
}

export const AuthFormLayout = ({
  children,
  onSubmit,
  title,
  subtitle,
  bottomText,
  handleResendResetClick,
  isArrow,
}: IAuthFormLayoutProps) => {
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      {/* Named rather than decorative: on the login and reset screens this is
          the only thing identifying which product is being signed in to. */}
      <img className={styles.logo} src={logo} alt="CodeBlue" />
      <p className={styles.title}>
        {isArrow && (
          <button
            type="button"
            aria-label="Back to login"
            className="reset-password-arrow"
            onClick={() => navigate(routes.AUTH.LOG_IN)}
          >
            <LeftArrow />
          </button>
        )}

        {title}
      </p>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      {children}
      <div className={styles.buttonContainer}>
        <CustomButton title={'Submit'} handleClick={onSubmit} />
      </div>

      {bottomText && (
        <button
          type="button"
          onClick={handleResendResetClick}
          className={styles.customLink}
        >
          {bottomText}
        </button>
      )}
    </div>
  );
};
